export const FEATURE = {
  RIVER: "0",
  WATERSHED: "1",
  ADMIN: "2",
};
